import PropTypes from "prop-types";
import { Box, ButtonBase, InputAdornment, TextField, Tooltip } from "@mui/material";
import { Check, ColorLens } from "@mui/icons-material";
import BikeColor from "./BikeColor";
import { getBikeColors } from "../model/bikeColors";

const options = [
  "Rojo",
  "Azul",
  "Verde",
  "Negro",
  "Blanco",
  "Gris",
  "Plata",
  "Amarillo",
  "Naranja",
  "Morado",
  "Rosado",
  "Café",
];

export default function BikeColorPicker({
  value,
  onChange,
  onBlur,
  disabled,
  error,
  helperText,
  sx,
}) {
  return (
    <Box>
      <TextField
        fullWidth
        size="small"
        label="Color *"
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
        error={error}
        helperText={helperText || "Elige un color o escribe una combinación."}
        placeholder="Ej: Verde o rojo y negro"
        sx={sx}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <ColorLens sx={{ color: "#5c6bc0" }} />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <BikeColor value={value} showLabel={false} />
            </InputAdornment>
          ) : null,
        }}
      />
      <Box
        role="group"
        aria-label="Colores de bicicleta"
        sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}
      >
        {options.map((name) => {
          const color = getBikeColors(name)[0];
          const selected = value.trim().toLowerCase() === name.toLowerCase();
          const checkColor = ["Negro", "Azul", "Verde", "Rojo", "Morado", "Café"].includes(name)
            ? "#fff"
            : "#243b53";
          return (
            <Tooltip title={name} key={name}>
              <span>
                <ButtonBase
                  type="button"
                  aria-label={`Color ${name}`}
                  aria-pressed={selected}
                  disabled={disabled}
                  onClick={() => onChange(name.toLowerCase())}
                  sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    bgcolor: color,
                    border: "1px solid #9aaaba",
                    outline: selected ? "2px solid #245a83" : "none",
                    outlineOffset: 2,
                    opacity: disabled ? 0.5 : 1,
                    "&:hover": { boxShadow: "0 0 0 3px #dbe8f2" },
                    "&.Mui-focusVisible": { outline: "3px solid #245a83", outlineOffset: 2 },
                  }}
                >
                  {selected && <Check sx={{ fontSize: 19, color: checkColor }} />}
                </ButtonBase>
              </span>
            </Tooltip>
          );
        })}
      </Box>
    </Box>
  );
}
BikeColorPicker.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  sx: PropTypes.object,
};
